module.exports = __webpack_public_path__ + "b3c7f0b8bb981d11b600fb8e719e5d4b.jpg";